import AsyncStorage from "@react-native-async-storage/async-storage";

const unauthorizedListeners = new Set();

export function subscribeToUnauthorized(listener) {
  unauthorizedListeners.add(listener);
  return () => unauthorizedListeners.delete(listener);
}

export async function clearStoredAuth() {
  await Promise.all([
    AsyncStorage.removeItem("userName"),
    AsyncStorage.removeItem("userToken"),
    AsyncStorage.removeItem("userData"),
  ]);
}

export async function handleUnauthorizedLogout() {
  await clearStoredAuth();
  unauthorizedListeners.forEach((listener) => listener());
}

export async function authenticatedFetch(url, options = {}) {
  const token = await AsyncStorage.getItem("userToken");
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    await handleUnauthorizedLogout();
  }

  return response;
}
